import { Component, Input, OnInit } from '@angular/core';


import { PATH } from '@app/constants';
import { DevelopmentInfo, DevelopmentParticipations, DevelopmentPhase, ParticipationsInfo } from '@interfaces/app';

@Component({
   selector: 'mnf-project-info-card',
   templateUrl: './project-info-card.component.html',
   styleUrls: ['./project-info-card.component.scss']
})
export class ProjectInfoCardComponent implements OnInit {
   @Input() dev: DevelopmentInfo;
   @Input() devParts: DevelopmentParticipations;
   @Input() userParts: ParticipationsInfo[];
   @Input() allUsersParts: number;

   letraEjemplo: string = 'MB10';

   percentage: number;
   message: string;
   restDayTotal: Number;

   userHaveParts = false;

   resaleUserPartPath = PATH.ROUTE_RESALE_SET_ON_SALE;
   resaleBuyUserPartPath = PATH.ROUTE_RESALE_MARKET;

   phasesView = true;

   percentPhase = '0.00';
   selectedPhase: DevelopmentPhase;
   estimatedFunded: string;

   indexPhase = 1;
   maxPhase = 1;

   estimatedFundedTime: string;
   showPerformance: { percent: number, info: string }[] = [];
   showPerformanceWithoutCTC: { percent: number, info: string }[] = [];

   dayRestInProject: number;
   textDateToInvest: string;

   labelFreeParts: string;

   sumAllPhases: any;

   constructor() { }

   ngOnInit(): void {
      this.dev.phases.sort((a, b) => new Date(a.publishedAt).getTime() > new Date(b.publishedAt).getTime() ? 1 : -1);
      this.percentage = (this.devParts.active / this.devParts.total) * 100;
      this.indexPhase = this.dev.phases.length;
      this.selectPhase(this.indexPhase - 1);
      this.maxPhase = this.dev.phases.length;


      // Comprobar si el proyecto es residencia para mostrar la nueva card
      if((this.dev.state === 'residential' || this.dev.multiplePerformance ) && this.dev?.devInfoDetail?.outEstimateResidential == null) {
         this.showPerformance = this.getValuesPerformance(this.dev?.devInfoDetail?.monthsEstimateResidential);
      }

      if((this.dev?.state === 'residential' || this.dev.multiplePerformance ) && this.dev?.devInfoDetail?.outEstimateResidential != null) {
         this.showPerformanceWithoutCTC = this.getValuesPerformanceWithoutCTC(this.dev?.devInfoDetail?.outEstimateResidential);
      }

      if (this.devParts?.maxDateToInvest) {
         const daysLeftToInvest = this.calculateDaysDifference(this.devParts?.maxDateToInvest);
         this.textDateToInvest = this.getTitleDaysLeftToInvest(daysLeftToInvest);
      }

      if(this.dev.name == 'Casa Roma Norte') {
         this.sumAllPhases = this.fundedTotal();
      }

      setTimeout(()=>{
         // Monto maximo
         const total = Number(this.devParts?.total);
         // Monto minimo
         let minAmountProject = Number(this.devParts?.minAmountProject);

         if(minAmountProject == 0) {
            minAmountProject = this.calculateAutoPercent(total);
            this.devParts.minAmountProject = minAmountProject;
         }

         // Fondeo
         const active = Number(this.devParts?.active);

         let percentMinAmount = (Number(active) / Number(minAmountProject)) * 90;

         if(this.devParts?.free === 0) {
            this.percentage = 100;
            this.message = `100%`;
            this.labelFreeParts = 'Proyecto fondeado';
         } else if (this.devParts?.total == minAmountProject) {
            this.percentage = (Number(active) / Number(this.devParts?.total)) * 100;
            this.message = `${this.percentage.toFixed(2)}%`;
            this.labelFreeParts = `Restan <strong class='part'>${total - active} participaciones </strong> para invertir`;
         } else if (percentMinAmount >= 90) {
            this.percentage = 90;
            this.message = 'Mínimo alcanzado';
            this.labelFreeParts = `Restan <strong class='part'>${total - active} participaciones </strong> para invertir`;

            if(active > minAmountProject) {
               let percentTotal = (Number(active) / Number(total)) * 100;
               if (percentTotal >= 95) {
                 this.percentage = percentTotal;
               }
            }

         } else if (percentMinAmount <= 90) {
            this.percentage = (Number(active) / Number(minAmountProject)) * 100;
            this.message = this.percentage.toFixed(2) + '%';
            this.labelFreeParts = `Restan <strong class='part'>${minAmountProject - active} participaciones </strong> para llegar al objetivo mínimo`;
         }
      }, 500)

   }

   selectPhase(index: number) {
      this.selectedPhase = this.dev.phases[index];
      this.userHaveParts = Boolean(this.userParts?.find(p => p.pid === this.dev.pid));
      this.percentPhase = ((this.selectedPhase.active / this.selectedPhase.total) * 100).toFixed(2);
   }

   forwardPhase() {
      const next = this.indexPhase - 1;

      if (next > 0) {
         this.indexPhase = next;
         this.selectPhase(next - 1);
      }
   }

   nextPhase() {
      const next = this.indexPhase + 1;

      if (next <= this.maxPhase) {
         this.indexPhase = next;
         this.selectPhase(next - 1);
      }
   }

   calculateAutoPercent(number: number) {
      return number * 0.20;
   }

   /** Función para obtener valores de rendimiento estimado de los proyectos tipo `ctc` */
   getValuesPerformance(arr: string[]): { percent: number, info: string }[] {
      const infos = ['Optimista', 'Estimado', 'Mínimo'];
      const elementosSeleccionados = [arr[0], arr[2], arr[arr.length - 1]];
      const valores = elementosSeleccionados.map((elemento, index) => ({
        percent: parseFloat(elemento.split('|')[1]),
        info: infos[index]
      }));

      return valores;
   }

   /** Función para obtener valores de rendimiento estimado de los proyectos tipo similar a `ctc` */
   getValuesPerformanceWithoutCTC(arr: string[]): { percent: number, info: string }[] {
      const infos = ['Optimista', 'Estimado', 'Conservador'];
      const elementosSeleccionados = [arr[0], arr[1], arr[2]];
      const valores = elementosSeleccionados.map((elemento, index) => ({
        percent: parseFloat(elemento),
        info: infos[index]
      }));

      return valores;
   }

   private isValidDateLimit(datelimit?: number): boolean {
      return typeof datelimit === 'number' && !isNaN(datelimit) && datelimit > 0;
    }

    calculateDaysDifference(datelimit?: number): number {
      const DAYS_FALLBACK = 60;
      const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;
      if (!this.isValidDateLimit(datelimit)) {
        return DAYS_FALLBACK;
      }
      const currentTime = Date.now();

      const timeDifference = datelimit! - currentTime;
      if (timeDifference <= 0) {
        return 0;
      }
      const daysDifference = timeDifference / MILLISECONDS_IN_A_DAY;
      return daysDifference >= 1 ? Math.floor(daysDifference) : 0;
    }

    getTitleDaysLeftToInvest(daysLeft: number): string {
      if (daysLeft <= 0) {
        return "Hoy es el último día para invertir";
      }
      return `Queda${daysLeft > 1 ? 'n' : ''} ${daysLeft} día${daysLeft > 1 ? 's' : ''} para invertir`;
    }

    toFixed(value: number | string): string {
      return Number(value).toFixed(2);
    }

   fundedTotal() {
      // Inicializa los valores acumulados
      let totalSum = 0;
      let activeSum = 0;
      let finalPublishedAt = "2024-01-18";
      let finalMaxDateToInvest = 1715839199000;
      let finalDiscount = "0.09";
      for (const obj of this.dev.phases) {
        totalSum += obj.total;
        activeSum += obj.active;
      }
      // Crear el nuevo objeto consolidado
      const result = {
        total: totalSum,
        publishedAt: finalPublishedAt,
        active: activeSum,
        expiredAt: null,
        maxDateToInvest: finalMaxDateToInvest,
        discount: finalDiscount
      };
      return result
   }

   rightPosition(): number {
      if (this.percentage < 10) {
        return -55;
      } else if (this.percentage > 90) {
        return -7;
      } else {
        return -28;
      }
    }

    getSpanTranslate(): string {
      if (this.percentage < 10) {
        return 'translate(-1.5rem, 1.7em) rotate(45deg)';
      } else if (this.percentage > 90) {
        return 'translate(1.4rem, 1.9em) rotate(45deg)';
      } else {
        return 'translate(0.2em, 1.9em) rotate(45deg)';
      }
    }

    getLetterClass(): string{
      const letterPrefix = this.letraEjemplo?.match(/^[A-Za-z]+/)?.[0] || '';
      const letterMap: { [key: string]:string } = {
        'B': 'rb-pos',
        'MB': 'mb-pos',
        'M': 'rm-pos',
        'A': 'ra-pos',
      };
      return letterMap[letterPrefix] || '';
    }

    openLink(url: string) {
      window.open(url, '_blank');
    }
}
